
import { Activity } from "../enums/Activity";
import { Document } from "./document";
import { DocumentReference } from "./document-reference";
import { NameValue } from "./name-value";
import { UserAction } from "./user-action";

export class VisualArtPerformance extends Document {

     constructor() {
          super();
     }

     id?: string;

     activity: Activity = Activity.Media;
     category?: NameValue;
     location: NameValue;
     format: DocumentReference;

     church: DocumentReference;

     approver: DocumentReference;

     memberList: DocumentReference[];
     
     status: NameValue;

     fileUrl: string;
     fileName: string;
     
     linkUrl: string;
     linkName: string;

     reviewFeedback: string;
     reviewUrl: string;

     approved: UserAction;
     isApprovalConfirmed: boolean;
     approvalFeedback: string;

     feePaid: UserAction;
     receiptNumber: string;

     isPaymentConfirmed: boolean;

     lyricsUploaded: UserAction;

     accepted: UserAction;

     rejected: UserAction;

     isSocialMediaConsentConfirmed: boolean;

     iReadGuideLines: boolean;

     isMemberFlagUpdated: boolean;
}